import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Label, theme } from "Application";
import { Row } from "../StudentTarget/StudentTargetView.styles";
import { StudentBehaviourViewModel } from "./StudentBehaviourViewModel";
import { StudentSessionBehaviourView } from "../StudentSessionBehaviour/StudentSessionBehaviourView";

export const StudentBehaviourView: React.FC<{ viewModel: StudentBehaviourViewModel }> = observer(({ viewModel }) => {
    return (
        <Box width="20%" minWidth={"350px"} maxWidth="50%" flex="1" border="1px solid #D4D4D4">
            <Box padding="10px" borderBottom="1px solid #D4D4D4" bg={theme.palette.tableHeader.light}>
                <Label fontStyle={"field"}>{viewModel.model.behaviourTypeName}</Label>
            </Box>
            <StudentSessionBehaviourView viewModel={viewModel.studentSessionBehaviourViewModel} />
        </Box>
    );
});
